import { z } from 'zod';
import { clipKindSchema } from '../clipKind';

export const clipSkipReasonSchema = z.enum(['missing-file', 'rejected', 'too-small']);

export const queueUploadResponseSchema = z.object({
  queued: z.boolean(),
  clipId: z.number(),
  jobs: z.array(
    z.object({
      id: z.number(),
      kind: clipKindSchema,
      skipped: clipSkipReasonSchema.optional(),
    }),
  ),
});

export type IQueueUploadResponse = z.infer<typeof queueUploadResponseSchema>;
